<template>
    <v-app id="dashboard-view" wrap>      
        
        <GlobalToolbar />
        <GlobalDrawer />       

        <v-main >
          <v-fade-transition mode="out-in">
            <v-container fluid>
              <router-view />
            </v-container>
          </v-fade-transition>
        </v-main>

    </v-app>
</template>


<script>
  export default {
    name: "DashboardView",
    metaInfo() {
      return {
        title: "Cemiterio Bilac"
      };
    }
  };
</script>

<style>
</style>